/** AUTOGENERATED FILE - DO NOT MODIFY!!!!! */
import { Observable } from 'rxjs/Observable';
import { Injectable } from '@angular/core';

import { CommunicationService } from '../communication/communication.service';
import { IClientOptions } from '../communication/interfaces/client-options.intefrace';
import { WebServiceResponseTyped } from '../models/ETG_SABENTISpro_Application_Core_models';

@Injectable({ providedIn: 'root' })
export class SabentisService
{
  constructor(public generalService: CommunicationService) {}

  /**
  *
  * Set a company in the current context
  *
  * @param {string} companyId
  * @param {string} centerId
  * @param {IClientOptions} clientOpts is an Object that contains optional value to define parameters on the client side
  * @returns {any}
  */
  getSetcompanyandcenterincontext(companyId: string, centerId: string, clientOpts: IClientOptions = {showSpinner: true}): Observable<WebServiceResponseTyped<any>>
  {
    const params: any = {'companyId' : companyId, 'centerId' : centerId};
    return this.generalService.get('sabentis/set-company-and-center-in-context', params, clientOpts) as Observable<WebServiceResponseTyped<any>>;
  }
}
